export const playCopy = {
  play_subnav_title: "Playground",
  play_subnav_config: "TS Config",
  play_config_language_blurb: "Which language should be used in the editor",
  play_subnav_handbook: "Help",
  play_subnav_examples: "Examples",
  play_subnav_examples_close: "Close",
  play_subnav_settings: "Settings",
  play_settings_tabs_settings: "Sidebar Tabs",
  play_downloading_typescript: "Downloading TypeScript...", // when loading
  play_downloading_version: "Version...", // when loading
  play_toolbar_run: "Run",
  play_toolbar_export: "Export",
  play_toolbar_share: "Share",
  play_sidebar_js: ".JS",
  play_sidebar_dts: ".D.TS",
  play_sidebar_errors: "Errors",
  play_sidebar_errors_no_errors: "No errors",
  play_sidebar_logs: "Logs",
  play_sidebar_logs_no_logs: "No logs",
  play_sidebar_options: "Options",
  play_sidebar_options_restart_required: "Browser Refresh Required",
  play_sidebar_options_disable_ata: "Disable ATA",
  play_sidebar_options_disable_ata_copy:
    "Disable the automatic acquisition of types for imports and requires.",
  play_sidebar_options_disable_save: "Disable Save-On-Type",
  play_sidebar_options_disable_save_copy:
    "Disable changing the URL when you type.",
  play_sidebar_plugins: "Plugins",
  play_sidebar_featured_plugins: "Featured Plugins",
  play_sidebar_plugins_options_external:
    "3rd Party Plugins <a href='https://www.npmjs.com/search?q=keywords:playground-plugin'>from npm</a>",
  play_sidebar_plugins_options_external_warning:
    "Warning: Code from plugins comes from third-parties.",
  play_sidebar_plugins_options_modules: "Custom npm Modules",
  play_sidebar_plugins_options_modules_placeholder: "Module name from npm.",
  play_sidebar_plugins_plugin_dev: "Plugin Dev",
  play_sidebar_plugins_plugin_dev_option:
    "Connect to <code>localhost:5000</code>",
  play_sidebar_plugins_plugin_dev_copy:
    "Automatically try to connect to a playground plugin in development mode. You can get started with <a href='/dev/playground-plugins/' title='Link to the page about Playground Plugins'>making a plugin here</a>.",
  play_export_report_issue: "Report GitHub issue on TypeScript",
  play_export_tweet_md: "Tweet link to Playground",
  play_export_copy_md: "Copy as Markdown Issue",
  play_export_copy_link: "Copy as Markdown Link",
  play_export_copy_link_preview: "Copy as Markdown Link with Preview",
  play_export_tsast: "Open in TypeScript AST Viewer",
  play_export_bugworkbench: "Open in Bug Workbench",
  play_export_vscode_dev_play: "Open in VSCode TS Playground (alpha)",
  play_export_sandbox: "Open in CodeSandbox",
  play_export_stackblitz: "Open in StackBlitz",
  play_export_clipboard: "URL copied to clipboard",
  play_esm_mode: "Switched to ESM mode",
  play_clear_logs: "Logs cleared",
  play_run_js: "Executed JavaScript",
  play_run_ts: "Executed transpiled TypeScript",
  play_run_js_fail: "Executed JavaScript Failed:",
  play_default_code_sample: `// Welcome to the TypeScript Playground, this is a website
// which gives you a chance to write, share and learn TypeScript.

// You could think of it in three ways:
//
//  - A location to learn TypeScript where nothing can break
//  - A place to experiment with TypeScript syntax, and share the URLs with others
//  - A sandbox to experiment with different compiler features of TypeScript

const anExampleVariable = "Hello World"
console.log(anExampleVariable)

// To learn more about the language, click above in "Examples" or "What's New".
// Otherwise, get started by removing these comments and the world is your playground.
  `,

  play_sidebar_js_title: "JavaScript",
  play_sidebar_js_blurb: "Shows the transpiled JS",

  play_sidebar_dts_title: "Definition Files",
  play_sidebar_dts_blurb: "Shows the .d.ts output of your code",

  play_sidebar_err_title: "Compiler Errors",
  play_sidebar_err_blurb: "Shows compiler errors in full",

  play_sidebar_run_title: "Run JavaScript in Browser",
  play_sidebar_run_blurb:
    "Shows the output of running the JavaScript in the editor",

  play_sidebar_plugins_title: "Manage Playground Plugins",
  play_sidebar_plugins_blurb:
    "Handles adding/removing 3rd party extensions to the playground",

  play_sidebar_ast_title: "[WIP] AST Viewer",
  play_sidebar_ast_blurb: "Inspect the TypeScript AST",

  play_sidebar_tools_filter_placeholder: "Filter",
  // Notes:
  // Compiler flag information is all from the tsconfig reference info
}
